<img
  src="../../../../assets/icons/add-aperture.svg"
  alt="no icon"
  class="icon"
  [ngClass]="{ disabled: !canUpdate }"
  (click)="openOpeningsDialog()"
/>
